import { useState } from "react"

import Input from "../Input"

const InputContainer = ({ onSubmit = () => { }, adviceText, ...inputProps }) => {
  const [inputValue, setInputValue] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()

    onSubmit(inputValue)
  }

  return (
    <form onSubmit={handleSubmit} className="w-full bg-red-75 py-3 px-7">
      {adviceText && (
        <span className="mb-3 inline-block text-black text-xs">{adviceText}</span>
      )}

      <Input onChange={e => setInputValue(e.target.value)} value={inputValue} required {...inputProps} />
    </form>
  )
}

export default InputContainer
